import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/button-icons/tick-icon-pink.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0093cc24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compare-reports hidden-xs" }
const _hoisted_2 = { class: "comparisons-container scrollbar" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "selected comparison"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "text-danger",
  "data-test": "no-available-comparisons-message"
}
const _hoisted_10 = ["disabled"]

import { Modal } from "uiv";
import { computed, ref, watchEffect } from "vue";
import { debug as d } from "debug";
import { csContext } from "../services/cs-context";
import {
  ReportComparisonApiModel,
  ReportSharingTypeApiModel,
  ReportToCompareApiModel,
} from "../api-models";
import { useToggle } from "../composables/useToggle";
import { useAxios } from "../composables/api";
import { Analytics } from "../services/analytics/analytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'compare-reports-button',
  props: {
    reportEntityId: {},
    reportType: {},
    isReportOnSelf: { type: Boolean }
  },
  setup(__props: any) {

const debug = d("cs.compareReports");

const props = __props;

const canCompareReport = ref(false);

const selectedComparison = ref<ReportToCompareApiModel | null>(null);

const { state, toggleState } = useToggle(false, (newValue: boolean) => {
  const eventName = newValue ? "Clicked Open Compare Reports" : "Clicked Cancel Compare Reports";
  Analytics.action(eventName, "CompareReports", {
    isReportOnSelf: props.isReportOnSelf,
    reportType: props.reportType,
    reportEntityId: props.reportEntityId,
  });
});

const { data } = useAxios<ReportComparisonApiModel>(
  `/api/reportcreation/potential-comparisons?reportType=${props.reportType}&reportEntityId=${props.reportEntityId}`,
);

const handleSelectedComparison = (comparison: ReportToCompareApiModel): void => {
  selectedComparison.value = comparison;
};

const handleConfirm = (): void => {
  if (selectedComparison.value) {
    const url = `/SoloReport/Compare/${data.value?.first.reportType}/${props.reportEntityId}/${selectedComparison.value.reportType}/${selectedComparison.value.reportId}`;
    Analytics.actionAsync("Clicked Confirm Compare Reports", "CompareReports", {
      isReportOnSelf: props.isReportOnSelf,
      reportType: props.reportType,
      reportEntityId: props.reportEntityId,
      secondReportType: selectedComparison.value.reportType,
      secondReportEntityId: selectedComparison.value.reportId,
    })
      .then(() => {
        window.location.href = url;
      })
      .catch((e) => {
        debug(e);
        window.location.href = url;
      });
  }
};

const noComparisonsAvailableMessage = computed(() => {
  if (csContext.currentTeam) {
    return "Your team mates need to share their reports in order for you to compare with them. They can do this by going to the team settings page and selecting yes under 'Sharing your reports'.";
  }
  return "You need to be in a team to compare reports.";
});

watchEffect(() => {
  if (data.value) {
    canCompareReport.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      modelValue: _unref(state),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(state) ? (state).value = $event : null)),
      title: "Select a team member to compare with..",
      "data-test": "compare-reports-picker"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: handleConfirm,
          class: "btn btn-primary",
          disabled: !selectedComparison.value,
          "data-test": "compare-picker-confirm-button",
          type: "button"
        }, " Confirm ", 8, _hoisted_10),
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleState) && _unref(toggleState)(...args))),
          "data-test": "compare-picker-cancel-button",
          type: "button"
        }, " Cancel ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(data) && canCompareReport.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).comparisons, (comparison) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: comparison.reportId,
                    class: "comparison"
                  }, [
                    _createElementVNode("button", {
                      class: "btn btn-default",
                      onClick: ($event: any) => (handleSelectedComparison(comparison)),
                      "data-test": "compare-picker-choice",
                      type: "button"
                    }, _toDisplayString(comparison.subjectName), 9, _hoisted_4),
                    (selectedComparison.value && selectedComparison.value.reportId === comparison.reportId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(noComparisonsAvailableMessage.value), 1)
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("button", {
      class: "btn btn-primary-compare",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleState) && _unref(toggleState)(...args))),
      "data-test": "compare-reports-button",
      type: "button"
    }, " Compare reports ")
  ]))
}
}

})